<template>
  <div>
    <!-- <top></top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img v-lazy="bgImg" alt class="imgSrcCss" />
        <div class="contentPosition">
          <div class="contentTop">钱大妈</div>
          <div class="contentBottom">
            <div>传统生鲜零售到数字化营销升级</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top: 118px">项目背景</div>
      <div class="lineCss"></div>
    </div>
    <!-- start -->
    <!-- start -->
    <div class="productParent marginTop109">
      <div class="productLeft">
        <img v-lazy="productLeft1" />
      </div>
      <div class="productRight">
        <div class="productRightTitle">
          <div class="titleBox1">
            <!-- <div class="anliTitle">项目背景</div>
            <div class="lineCss1"></div>-->
          </div>
        </div>
        <div class="productRightText paddingRight">
          钱大妈以售卖新鲜蔬菜、鲜肉为主营业务，需要实时
          传递商品‘新鲜’的理念。依据生鲜品类的售卖特点，会不定时有指定品类打折、针对区域门店的营销、根据时段等营销活动。当前的数字化的系统，主要依靠人工制作
          营销内容，再人工逐一投放，增加了人员成本。钱大妈希望能用数字化解决营销活动智能展示的效果，
          解放人工，提升运营效率。
        </div>
      </div>
    </div>
    <!-- end -->

    <div class="grayBox">
      <div class="titleBox" style="margin-top: 0">
        <div class="anliTitle">方案策略</div>
        <div class="lineCss"></div>
      </div>
      <div class="grayBoxText">
       根据 加盟/直营门店 的类型，通过多层级管理，进行 针对性的营销策略 管控；对接POS，根据商品库存量数据、保质期等，智能更新营销方案，如特价、打折等，强化‘不隔夜’的品牌理念， 降低货损，提升毛利率。POS数据对接 / 强管控运营提效 / 定时促销降货损。
      </div>
      <!-- detailList start -->
      <div class="detailList">
        <div class="detailBox">
          <img v-lazy="detailListIcon1" alt />
          <div class="detailBoxTitle">POS数据对接</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon2" alt />
          <div class="detailBoxTitle">定时促销降货损</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon3" alt />
          <div class="detailBoxTitle">强管控运营提效</div>
        </div>
       
      </div>
      <!-- detailList end -->
    </div>
    <!-- 场景解析 start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top: 138px">功能解析</div>
      <div class="lineCss"></div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <img v-lazy="northFace2" alt />
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle" style="padding: 0">
          POS对接 - 智能数据展示
        </div>
        <div class="bottomRightText">
          钱大妈具有多个POS系统，包括安卓及WINDOWS系统，通过标准化的数据接口，可以把每家店每个时段的价格、每个仓储区每个门店的促销商品图片等信息自动按规则拉取，全程智能化营销展示。
        </div>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">
          层级管理 - 分区域针对性营销
        </div>
        <div class="bottomRightText bottomRightTextTwo">
          根据钱大妈店面分布情况，设置六层级架构，总部-内陆/海外-省级-市级-门店，可针对同一层级进行区域化营销，比如针对新店、周年庆门店的针对性活动。
        </div>
      </div>

      <div class="bottomRight" style="width: 50%">
        <img v-lazy="wanDaContent3" alt />
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <img v-lazy="teBuContent5" alt />
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle" style="padding: 0">
          H5 模板 - 时段促销降货损
        </div>
        <div class="bottomRightText">
         为了保障品牌‘不卖隔夜肉’的理念，钱大妈的营销从每天19:00开始，不同时段进行不同程度的打折活动。应用数字屏的H5动态模板的定时播放功能，在不同时段，展示不同力度的打折营销海报。
        </div>
      </div>
    </div>

    <!-- 场景解析 end -->

    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/taiheTop.jpg";
import productLeft1 from "@/assets/images/taiHeImg1.jpg";

import wanDaContent2 from "@/assets/images/teBuContent1.png";
import wanDaContent3 from "@/assets/images/taiHeImg3.jpg";
import wanDaContent4 from "@/assets/images/teBuContent3.png";
import detailListIcon1 from "@/assets/images/taiHeIcon1_qian.png";
import detailListIcon2 from "@/assets/images/taiHeIcon2_qian.png";
import detailListIcon3 from "@/assets/images/taiHeIcon3_qian.png";
import detailListIcon4 from "@/assets/images/taiHeIcon4.png";
import detailListIcon5 from "@/assets/images/teBuIcon5.png";
import teBuContent5 from "@/assets/images/taiHeImg4.jpg";
import teBuContent6 from "@/assets/images/teBuContent6.png";
import teBuContent7 from "@/assets/images/teBuContent7.png";
import northFace2 from "@/assets/images/taiHeImg2.jpg";
import piglet5 from "@/assets/images/gxg5.png";

import Bread from "@/components/bread.vue";

export default {
  name: "CaseTaihe",
  components: {
    Top,
    Footer,
    Bread,
  },
  data() {
    return {
      northFace2: northFace2,
      teBuContent5: teBuContent5,
      teBuContent6: teBuContent6,
      teBuContent7: teBuContent7,
      toBreadChild: ["案例", "小猪班纳"],
      bgImg: bgImg,
      wanDaContent2: wanDaContent2,
      wanDaContent3: wanDaContent3,
      wanDaContent4: wanDaContent4,
      productLeft1: productLeft1,
      piglet5: piglet5,
      detailListIcon1: detailListIcon1,
      detailListIcon2: detailListIcon2,
      detailListIcon3: detailListIcon3,
      detailListIcon4: detailListIcon4,
      detailListIcon5: detailListIcon5,
    };
  },
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 888px;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 3.6rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}
.lineCss1 {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
  margin-bottom: 40px;
}
.lineCssTwo {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}
.titleBox1 {
}
.titleBoxTwo {
  margin-top: 100px;
  width: 80%;
  margin: auto;
}

/* end */
.productParent::after {
  content: "";
  display: block;
  clear: both;
}
.productParent {
  width: 70%;
  margin: auto;
}

.productLeft {
  width: 44%;
  padding-left: 3%;
  float: left;
}

.productLeft img {
  width: 100%;
}

.productRight {
  width: 44%;
  padding-left: 5%;
  float: left;
}

.productRightTitle {
  text-indent: 3.8rem;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  width: 82%;
}

.productRightText {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 33px;
}

.marginTop109 {
  margin-top: 45px;
}

.grayBoxText {
  width: 64%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 68px;
  text-indent: 40px;
}

.grayBox {
  background: rgba(240, 240, 240, 1);
  margin-top: 170px;
  padding-bottom: 68px;
  padding-top: 70px;
}

.detailList {
  display: flex;
  width: 70%;
  margin: auto;
}

.detailBox {
  width: 33%;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 40px;
}

.bottomParent {
  width: 70%;
  margin: auto;
}
.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}
.bottomLeft {
  width: 50%;
  float: left;
  margin-top: 84px;
}
.bottomLeft img {
  width: 97%;
  /* max-width: 586px; */
}
.bottomRight img {
  width: 97%;
  /* max-width: 586px; */
}
.bottomRight {
  margin-top: 84px;
  width: 46%;
  float: right;
}
.bottomRightTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 6%;
  padding-left: 10%;
}
.bottomRightText {
  margin-top: 4%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.bottomRightTitleTwo {
}
.bottomRightTextTwo {
  width: 80%;
  margin: auto;
  margin-top: 6%;
}
.paddingRight {
  padding-right: 5%;
}
.rightImgCss {
  width: 100%;
  max-width: 618px;
}
.gapCss {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: center;
  margin-top: 139px;
}
</style>



// WEBPACK FOOTER //
// src/view/CaseTaihe.vue